module.exports = __webpack_public_path__ + "static/media/boltOff_326.41fcb929.png";